import { render, staticRenderFns } from "./DeliveryMode.vue?vue&type=template&id=318e9162"
import script from "./DeliveryMode.vue?vue&type=script&lang=js"
export * from "./DeliveryMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318e9162')) {
      api.createRecord('318e9162', component.options)
    } else {
      api.reload('318e9162', component.options)
    }
    module.hot.accept("./DeliveryMode.vue?vue&type=template&id=318e9162", function () {
      api.rerender('318e9162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/DeliveryMode.vue"
export default component.exports